var map = {
	"./assets/img/generating/background.png": 125,
	"./assets/img/generating/colorLine.png": 124,
	"./assets/img/generating/generatingText.png": 126,
	"./assets/img/input/background.png": 123,
	"./assets/img/loading/background.png": 95,
	"./assets/img/page1/answerList.png": 102,
	"./assets/img/page1/background.png": 101,
	"./assets/img/page10/background.png": 122,
	"./assets/img/page2/background.png": 103,
	"./assets/img/page2/colorfulLine.png": 104,
	"./assets/img/page2/彩条上文字.png": 318,
	"./assets/img/page3/background.png": 105,
	"./assets/img/page3/blackBlock.png": 319,
	"./assets/img/page4/background.png": 106,
	"./assets/img/page4/dot.png": 108,
	"./assets/img/page4/pin.png": 107,
	"./assets/img/page5/background.png": 109,
	"./assets/img/page5/colorLine.png": 110,
	"./assets/img/page6/background.png": 111,
	"./assets/img/page6/circleList.png": 112,
	"./assets/img/page6/colorful-circle.png": 320,
	"./assets/img/page7/background.png": 113,
	"./assets/img/page7/colorShape.png": 114,
	"./assets/img/page8/background.png": 115,
	"./assets/img/page8/roateAnimation.png": 116,
	"./assets/img/page9/background.png": 117,
	"./assets/img/page9/css_sprites (26).png": 321,
	"./assets/img/page9/hand.png": 121,
	"./assets/img/page9/progress-bg.png": 119,
	"./assets/img/page9/progress.png": 118,
	"./assets/img/page9/wrapAnimation.png": 120,
	"./assets/img/share/background.png": 127,
	"./assets/img/share/bgs/conscientiousness/1-1.png": 131,
	"./assets/img/share/bgs/conscientiousness/1.5-1.png": 132,
	"./assets/img/share/bgs/conscientiousness/2-1.png": 133,
	"./assets/img/share/bgs/conscientiousness/2.5-1.png": 134,
	"./assets/img/share/bgs/conscientiousness/3-1.png": 135,
	"./assets/img/share/bgs/conscientiousness/3.5-1.png": 136,
	"./assets/img/share/bgs/conscientiousness/3.5-2.png": 137,
	"./assets/img/share/bgs/conscientiousness/3.5-3.png": 138,
	"./assets/img/share/bgs/conscientiousness/4-1.png": 139,
	"./assets/img/share/bgs/conscientiousness/4-2.png": 140,
	"./assets/img/share/bgs/conscientiousness/4-3.png": 141,
	"./assets/img/share/bgs/conscientiousness/4-4.png": 142,
	"./assets/img/share/bgs/conscientiousness/4-5.png": 143,
	"./assets/img/share/bgs/conscientiousness/4.5-1.png": 144,
	"./assets/img/share/bgs/conscientiousness/5-1.png": 145,
	"./assets/img/share/bgs/extroversion/1-1.png": 146,
	"./assets/img/share/bgs/extroversion/1-2.png": 147,
	"./assets/img/share/bgs/extroversion/1.5-1.png": 148,
	"./assets/img/share/bgs/extroversion/2-1.png": 149,
	"./assets/img/share/bgs/extroversion/2-2.png": 150,
	"./assets/img/share/bgs/extroversion/2.5-1.png": 151,
	"./assets/img/share/bgs/extroversion/3-1.png": 152,
	"./assets/img/share/bgs/extroversion/3-2.png": 153,
	"./assets/img/share/bgs/extroversion/3.5-1.png": 154,
	"./assets/img/share/bgs/extroversion/3.5-2.png": 155,
	"./assets/img/share/bgs/extroversion/3.5-3.png": 156,
	"./assets/img/share/bgs/extroversion/4-1.png": 157,
	"./assets/img/share/bgs/extroversion/4-2.png": 158,
	"./assets/img/share/bgs/extroversion/4.5-1.png": 159,
	"./assets/img/share/bgs/extroversion/5-1.png": 160,
	"./assets/img/share/bgs/nervousness/1-1.png": 161,
	"./assets/img/share/bgs/nervousness/1.5-1.png": 162,
	"./assets/img/share/bgs/nervousness/2-1.png": 163,
	"./assets/img/share/bgs/nervousness/2.5-1.png": 164,
	"./assets/img/share/bgs/nervousness/2.5-2.png": 165,
	"./assets/img/share/bgs/nervousness/3-1.png": 166,
	"./assets/img/share/bgs/nervousness/3.5-1.png": 167,
	"./assets/img/share/bgs/nervousness/3.5-2.png": 168,
	"./assets/img/share/bgs/nervousness/4-1.png": 169,
	"./assets/img/share/bgs/nervousness/4.5-1.png": 170,
	"./assets/img/share/bgs/nervousness/5-1.png": 171,
	"./assets/img/share/bgs/open/1-1.png": 172,
	"./assets/img/share/bgs/open/1.5-1.png": 173,
	"./assets/img/share/bgs/open/2-1.png": 174,
	"./assets/img/share/bgs/open/2.5-1.png": 175,
	"./assets/img/share/bgs/open/2.5-2.png": 176,
	"./assets/img/share/bgs/open/3-1.png": 177,
	"./assets/img/share/bgs/open/3-2.png": 178,
	"./assets/img/share/bgs/open/3.5-1.png": 179,
	"./assets/img/share/bgs/open/3.5-2.png": 180,
	"./assets/img/share/bgs/open/3.5-3.png": 181,
	"./assets/img/share/bgs/open/4-1.png": 182,
	"./assets/img/share/bgs/open/4-2.png": 183,
	"./assets/img/share/bgs/open/4-3.png": 184,
	"./assets/img/share/bgs/open/4.5-1.png": 185,
	"./assets/img/share/bgs/open/4.5-2.png": 186,
	"./assets/img/share/bgs/open/4.5-3.png": 187,
	"./assets/img/share/bgs/open/5-1.png": 188,
	"./assets/img/share/bgs/pleasant/1.5-1.png": 189,
	"./assets/img/share/bgs/pleasant/1.5-2.png": 190,
	"./assets/img/share/bgs/pleasant/2.5-1.png": 191,
	"./assets/img/share/bgs/pleasant/2.5-2.png": 192,
	"./assets/img/share/bgs/pleasant/2.5-3.png": 193,
	"./assets/img/share/bgs/pleasant/3-1.png": 194,
	"./assets/img/share/bgs/pleasant/3-2.png": 195,
	"./assets/img/share/bgs/pleasant/3.5-1.png": 196,
	"./assets/img/share/bgs/pleasant/4-1.png": 197,
	"./assets/img/share/bgs/pleasant/4-10.png": 198,
	"./assets/img/share/bgs/pleasant/4-2.png": 199,
	"./assets/img/share/bgs/pleasant/4-3.png": 200,
	"./assets/img/share/bgs/pleasant/4-4.png": 201,
	"./assets/img/share/bgs/pleasant/4-5.png": 202,
	"./assets/img/share/bgs/pleasant/4-6.png": 203,
	"./assets/img/share/bgs/pleasant/4-7.png": 204,
	"./assets/img/share/bgs/pleasant/4-8.png": 205,
	"./assets/img/share/bgs/pleasant/4-9.png": 206,
	"./assets/img/share/code.png": 130,
	"./assets/img/share/level2/conscientiousness.png": 322,
	"./assets/img/share/level2/extroversion.png": 323,
	"./assets/img/share/level2/nervousness.png": 324,
	"./assets/img/share/level2/open.png": 325,
	"./assets/img/share/level2/pleasant.png": 326,
	"./assets/img/share/radarCircle.png": 128,
	"./assets/img/share/radarText.png": 129,
	"./assets/img/share/tips/conscientiousness/1-1.png": 207,
	"./assets/img/share/tips/conscientiousness/1.5-1.png": 208,
	"./assets/img/share/tips/conscientiousness/2-1.png": 209,
	"./assets/img/share/tips/conscientiousness/2.5-1.png": 210,
	"./assets/img/share/tips/conscientiousness/3-1.png": 211,
	"./assets/img/share/tips/conscientiousness/3.5-1.png": 212,
	"./assets/img/share/tips/conscientiousness/3.5-2.png": 213,
	"./assets/img/share/tips/conscientiousness/3.5-3.png": 214,
	"./assets/img/share/tips/conscientiousness/4-1.png": 215,
	"./assets/img/share/tips/conscientiousness/4-2.png": 216,
	"./assets/img/share/tips/conscientiousness/4-3.png": 217,
	"./assets/img/share/tips/conscientiousness/4-4.png": 218,
	"./assets/img/share/tips/conscientiousness/4.5-1.png": 219,
	"./assets/img/share/tips/conscientiousness/5-1.png": 220,
	"./assets/img/share/tips/extroversion/1-1.png": 221,
	"./assets/img/share/tips/extroversion/1-2.png": 222,
	"./assets/img/share/tips/extroversion/1.5-1.png": 223,
	"./assets/img/share/tips/extroversion/2-1.png": 224,
	"./assets/img/share/tips/extroversion/2.5-1.png": 225,
	"./assets/img/share/tips/extroversion/3-1.png": 226,
	"./assets/img/share/tips/extroversion/3-2.png": 227,
	"./assets/img/share/tips/extroversion/3.5-1.png": 228,
	"./assets/img/share/tips/extroversion/3.5-2.png": 229,
	"./assets/img/share/tips/extroversion/4-1.png": 230,
	"./assets/img/share/tips/extroversion/4.5-1.png": 231,
	"./assets/img/share/tips/extroversion/5-1.png": 232,
	"./assets/img/share/tips/nervousness/1-1.png": 233,
	"./assets/img/share/tips/nervousness/1.5-1.png": 234,
	"./assets/img/share/tips/nervousness/2-1.png": 235,
	"./assets/img/share/tips/nervousness/2.5-1.png": 236,
	"./assets/img/share/tips/nervousness/3-1.png": 237,
	"./assets/img/share/tips/nervousness/3.5-1.png": 238,
	"./assets/img/share/tips/nervousness/3.5-2.png": 239,
	"./assets/img/share/tips/nervousness/4-1.png": 240,
	"./assets/img/share/tips/nervousness/4.5-1.png": 241,
	"./assets/img/share/tips/nervousness/5-1.png": 242,
	"./assets/img/share/tips/open/1-1.png": 243,
	"./assets/img/share/tips/open/1.5-1.png": 244,
	"./assets/img/share/tips/open/2-1.png": 245,
	"./assets/img/share/tips/open/2.5-1.png": 246,
	"./assets/img/share/tips/open/3-1.png": 247,
	"./assets/img/share/tips/open/3-2.png": 248,
	"./assets/img/share/tips/open/3.5-1.png": 249,
	"./assets/img/share/tips/open/3.5-2.png": 250,
	"./assets/img/share/tips/open/4-1.png": 251,
	"./assets/img/share/tips/open/4-2.png": 252,
	"./assets/img/share/tips/open/4-3.png": 253,
	"./assets/img/share/tips/open/4.5-1.png": 254,
	"./assets/img/share/tips/open/4.5-2.png": 255,
	"./assets/img/share/tips/open/4.5-3.png": 256,
	"./assets/img/share/tips/open/5-1.png": 257,
	"./assets/img/share/tips/pleasant/1.5-1.png": 258,
	"./assets/img/share/tips/pleasant/1.5-2.png": 259,
	"./assets/img/share/tips/pleasant/2.5-1.png": 260,
	"./assets/img/share/tips/pleasant/2.5-2.png": 261,
	"./assets/img/share/tips/pleasant/2.5-3.png": 262,
	"./assets/img/share/tips/pleasant/3-1.png": 263,
	"./assets/img/share/tips/pleasant/3.5-1.png": 264,
	"./assets/img/share/tips/pleasant/3.5-2.png": 265,
	"./assets/img/share/tips/pleasant/4-1.png": 266,
	"./assets/img/share/tips/pleasant/4-10.png": 267,
	"./assets/img/share/tips/pleasant/4-2.png": 268,
	"./assets/img/share/tips/pleasant/4-3.png": 269,
	"./assets/img/share/tips/pleasant/4-4.png": 270,
	"./assets/img/share/tips/pleasant/4-5.png": 271,
	"./assets/img/share/tips/pleasant/4-6.png": 272,
	"./assets/img/share/tips/pleasant/4-7.png": 273,
	"./assets/img/share/tips/pleasant/4-8.png": 274,
	"./assets/img/share/tips/pleasant/4-9.png": 275,
	"./assets/img/start/answerAndAvator.png": 98,
	"./assets/img/start/background.png": 96,
	"./assets/img/start/cilcleList.png": 100,
	"./assets/img/start/startAnswer.png": 97,
	"./assets/img/start/text.png": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 276;